import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';
import { flowRight as compose } from 'lodash';
import { gql } from '@apollo/client';
import { FormControl } from 'react-bootstrap';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';

import { changePayout } from '../../actions/TransactionHistory/changePayout';
import { payoutChangeListing } from '../../actions/Payout/payoutChangeListing';
import Link from '../Link';

import messages from '../../locale/jsonMessages';
import { withQuery } from '../../hoc/withGraphql';

import cs from '../../components/commonStyle.css'
import s from './Transaction.css';

const Payouts = (props) => {
    const {
        className, data: { loading, getPayouts }, defaultValue,
        enableAddPayout, type, reservationId, mode,
        handleResults, listId
    } = props;

    const { formatMessage } = useIntl();
    const [payoutId, setPayoutId] = useState(defaultValue || '0');

    useEffect(() => {
        setPayoutId(defaultValue || '0');
    }, [defaultValue]);
    const dispatch = useDispatch();

    const handleChange = (e) => {
        const selectedValue = e.target.value;
        setPayoutId(selectedValue);

        if (type === 'change') {
            dispatch(changePayout(selectedValue, reservationId));
        } else {
            dispatch(payoutChangeListing(selectedValue));
            handleResults && handleResults(mode, selectedValue, listId);
        }
    }

    if (enableAddPayout) {
        // getPayouts is undefined when its query fails (e.g. payment provider not configured): do not crash the whole page
        if (!loading && (!getPayouts || getPayouts.length === 0)) {
            return (
                <Link to={"/user/payout"} className={cx(s.confirmCodeColor)}>
                    <FormattedMessage {...messages.transactionsAddPayout} />
                </Link>
            );
        }
    }

    return (
        <FormControl
            componentClass="select"
            className={cx(cs.formControlSelect, 'selectContainer', 'selectContainerRTL', className)}
            onChange={handleChange}
            value={payoutId}
        >
            <option value="0">{formatMessage(messages.default)}</option>
            {
                !loading && getPayouts && getPayouts.map((item, index) => {
                    if (item.paymentMethod.id === 2 && item.isVerified) {
                        return (
                            <option
                                value={item.id}
                                key={index}
                            >
                                ******{item.last4Digits}
                            </option>
                        )
                    } else if (item.isVerified) {
                        return (
                            <option
                                value={item.id}
                                key={index}
                            >
                                {item.payEmail}
                            </option>
                        )
                    }

                })

            }
        </FormControl>
    );
}

Payouts.propTypes = {
    className: PropTypes.string,
    data: PropTypes.shape({
        loading: PropTypes.bool,
        getPayouts: PropTypes.arrayOf(PropTypes.shape({
            id: PropTypes.number.isRequired,
            payEmail: PropTypes.string.isRequired
        }))
    }),
    type: PropTypes.string,
    reservationId: PropTypes.number,
    defaultLabel: PropTypes.string,
    defaultValue: PropTypes.number,
    enableAddPayout: PropTypes.bool,
    mode: PropTypes.string,
    handleResults: PropTypes.func,
    listId: PropTypes.number
};

export default compose(
    withStyles(cs, s),
    withQuery(gql`
    	query getPayouts {
		  getPayouts {
		    id
		    methodId
		    paymentMethod{
		      id
		      name
		    }
		    userId
		    payEmail
		    address1
		    address2
		    city
		    state
		    country
		    zipcode
		    currency
		    default
		    createdAt
            status
            last4Digits
            isVerified
		  }
		}
    `,
        {
            options: {
                ssr: false
            }
        }),
)(Payouts);